<template>
    <svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect class="navbar_hoverEffect_second" x="1" y="1" width="19" height="23" rx="2" stroke-width="2" stroke-linejoin="round"/>
        <rect class="navbar_hoverEffect" x="5.5" y="10.5" width="10" height="1" rx="0.5"  stroke-linejoin="round"/>
        <rect class="navbar_hoverEffect" x="5.5" y="15.5" width="10" height="1" rx="0.5" stroke-linejoin="round"/>
        <rect class="navbar_hoverEffect_second" x="1.5" y="5.5" width="18" height="1" rx="0.5" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
  name: 'NewsIcon'
}
</script>

<style scoped>
path {
    stroke: var(--nav-menu-new-icon);
}
circle {
    stroke: var(--nav-menu-new-icon);
}
rect {
    stroke: var(--nav-menu-new-icon);
}
</style>
